function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.5,0h0C5.6,0,0,5.6,0,12.5h0c0,6.9,5.6,12.5,12.5,12.5h0c6.9,0,12.5-5.6,12.5-12.5h0C25,5.6,19.4,0,12.5,0Zm5.95,10.52c0,.13-.11.25-.25.24-2.52-.07-3.22-1.24-3.22-1.24v5.95c0,2.33-1.89,4.21-4.21,4.21-2.48,0-4.47-2.15-4.19-4.69.21-1.93,1.77-3.48,3.69-3.7.26-.03.52-.04.77-.02.12,0,.22.12.22.24v1.75c0,.15-.13.25-.27.24-.16-.02-.33-.02-.51,0-.87.12-1.58.84-1.68,1.71-.15,1.24.84,2.29,2.06,2.23,1.07-.05,1.89-.98,1.89-2.05V5.56c0-.13.11-.24.24-.24h2c.13,0,.24.1.25.22.09,1.38,1.02,2.88,2.98,2.99.13,0,.23.11.23.24v1.75Z"
});

var SvgEroskiFooter3Tiktok = function SvgEroskiFooter3Tiktok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "tik_tok",
    "data-name": "tik tok",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter3Tiktok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer3-tiktok.e0449410.svg";
export { ForwardRef as ReactComponent };